var css = {"buttonBase":"ButtonBase-module_buttonBase__1pgYp"};

export { css as default };
